module.exports = __webpack_public_path__ + "img/bd9dfc0.jpg";